// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"3bd62c92","453":"3bfe28d4","717":"9946a424","765":"78df5d1f","785":"600c1418"}[chunkId] + ".chunk.js";
};